import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TrainingProjectsStores } from '../stores';
import { STORE_TRAINING_PROJECT_DASHBOARD, STORE_TRAINING_PROJECTS } from '../stores/constants';
import { TrainingProjectDashboard } from '../components';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';

const TrainingProjectDashboardScreen: React.FC<TrainingProjectsStores> = ({
    trainingProjectDashboardStore,
    trainingProjectsStore
}) => {
    if (!trainingProjectDashboardStore || !trainingProjectsStore) {
        return null;
    }

    return (
        <HasPermission
            permissionClaim={AppPermissions.CanEditMlStorage}
            yes={() => (
                <TrainingProjectDashboard
                    store={trainingProjectDashboardStore}
                    trainingProjectsStore={trainingProjectsStore}
                />
            )}
        />
    );
};

export default inject(
    STORE_TRAINING_PROJECT_DASHBOARD,
    STORE_TRAINING_PROJECTS
)(observer(TrainingProjectDashboardScreen));
